<app-lms-modal-frame [title]="'Remove Laundering Scorecard'" [pageHeadWidth]="400">
    <div modal-body>
        <form novalidate>
            <p align="center" style="color: red; font-size: 16px;">
                <b>Are you sure you want to remove the risk score? This is permanent.</b>
            </p>

            <table id="clientInfo" class="table table-striped table-light table-hover table-sm mb-3 w-100">
                <caption>Laundering Score Details</caption>
                <tbody>
                    <tr align="left">
                        <td style="width: 25%;">Parameter Type</td>
                        <td style="width: 25%;">{{riskScorecardInfo.parameterType}}</td>
                    </tr>
                    <tr align="left">
                        <td style="width: 25%;">Description</td>
                        <td style="width: 25%;">{{riskScorecardInfo.description}}</td>
                    </tr>

                    <tr align="left">
                        <td>Score</td>
                        <td>{{riskScorecardInfo.score}}</td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>

    <div modal-actions class="lms-action-bar">
        <button class="btn btn-primary me-2" mdbRipple (click)="close()">No</button>
        <button class="btn btn-danger" (click)="removeScoreCardConfirmation()">Yes</button>
    </div>
</app-lms-modal-frame>
